export default __webpack_public_path__ + "static/media/ny-cityguide-05.ee46287d.jpg";